class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.item = $(this).closest(".productView");
    this.isFullWidth = this.item.is(".layout-4");

    this.onVariantInit();
    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  onVariantInit() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia(1500);
    // this.updateURL();
    this.renderProductAjaxInfo();
    this.renderProductInfo();
    if (!this.currentVariant) {
      this.updateAttribute(true);
    } else {
      this.updateAttribute(false, !this.currentVariant.available);
    }
    this.updateVariantStatuses();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.updateAttribute(true);
      this.updateStickyAddToCart(true);
    } else {
      this.updateMedia(200);
      this.updateURL();
      this.updateVariantInput();
      this.renderProductAjaxInfo();
      this.renderProductInfo();
      this.updateProductInfo();
      this.updateAttribute(false, !this.currentVariant.available);
      this.updateStickyAddToCart(false, !this.currentVariant.available);
      this.checkQuantityWhenVariantChange();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  decodeOptions() {
    this.options = this.options.map((option) => {
      const parsedOption = this.decodeOption(option);
      return parsedOption;
    });
  }

  decodeOption(option) {
    if (option) {
      return option
        .split("Special_Double_Quote")
        .join('"')
        .split("Special_Slash")
        .join("/");
    } else {
      return null;
    }
  }

  encodeOption(option) {
    if (option) {
      return option
        .split('"')
        .join("Special_Double_Quote")
        .split("/")
        .join("Special_Slash");
    } else {
      return null;
    }
  }

  updateMasterId() {
    this.decodeOptions();
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia(time) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const newMedia = document.querySelectorAll(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    // Define the specific media ID to be active
    const specificMediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
    const allMedia = document.querySelectorAll("[data-media-id]");
    let Active_img_alt = "";

    allMedia.forEach(function (element) {
      const mediaId = element.getAttribute("data-media-id");

      if (mediaId === specificMediaId) {
        element.classList.add("active-carousel");
        // console.log("Active Element:", element);

        const imgCarouselContainer = element.querySelector(
          ".productView-thumbnail-link"
        );
        if (imgCarouselContainer) {
          const imgCarousel = imgCarouselContainer.querySelector("img");
          if (imgCarousel) {
            Active_img_alt = imgCarousel.getAttribute("alt");
            // console.log("Image Alt:", Active_img_alt);

            var selectedVariantAlt = document.getElementsByClassName('selected_variant');
             var selectedVariantText_firstoption = selectedVariantAlt[0].innerText ;
            var selectedVariantText = "";

          if (selectedVariantAlt.length > 0) {
             var variants = [];

            for (var i = 0; i < selectedVariantAlt.length; i++) {
               variants.push(selectedVariantAlt[i].innerText.trim());
               }

                selectedVariantText = variants.join(" / ");
         }

            // console.log("imagevar text" , selectedVariantText )

            const hideProductMediaContainers = document.getElementsByClassName("product_media_container");
            const hideClonedGalleryWrappers = document.getElementsByClassName("cloned-gallery-wrapper");
          debugger;
           if( selectedVariantText.toLowerCase() === Active_img_alt.toLowerCase()){
              // console.log("yes has main varinat image");
              Array.from(hideProductMediaContainers).forEach((element) => {
                element.style.display = "none";
              });
              Array.from(hideClonedGalleryWrappers).forEach((element) => {
                element.style.display = "block";
              });

              // console.log("cloned media wrapper");
            }  
            else{
              if(selectedVariantText_firstoption.toLowerCase() === Active_img_alt.toLowerCase()){
              Array.from(hideProductMediaContainers).forEach((element) => {
                element.style.display = "none";
              });
              Array.from(hideClonedGalleryWrappers).forEach((element) => {
                element.style.display = "block";
              });

              }
              else{
                
              var AltproductTitle = document.querySelector(".productView-title").querySelectorAll("span")[0].innerText;

              if(AltproductTitle.toLowerCase() === Active_img_alt.toLowerCase()){
              Array.from(hideClonedGalleryWrappers).forEach((element) => {
                element.style.display = "none";
              });
              Array.from(hideProductMediaContainers).forEach((element) => {
                element.style.display = "block";
              });
              }else{
              const selectedVariants = document.querySelectorAll('.selected_variant');
 

              Array.from(hideClonedGalleryWrappers).forEach((element) => {
                element.style.display = "none";
              });
              Array.from(hideProductMediaContainers).forEach((element) => {
                element.style.display = "block";
              });
            }
            }
              // console.log("product media container")
              
              // console.log("Not main varinat image")
            
          }
            // Select all thumbnail images
            const thumbnails = document.querySelectorAll(
              ".productView-thumbnail .productView-thumbnail-link img"
            );

            // Initialize counter for matching thumbnails
            let matchingCount = 0;

            thumbnails.forEach((thumbnail) => {
              const img_alt = thumbnail.getAttribute("alt");
              if (img_alt === Active_img_alt) {
                // console.log("present", thumbnail.alt);
                const thumbnailContainer = thumbnail.closest(
                  ".productView-thumbnail"
                );
                if (thumbnailContainer) {
                  thumbnailContainer.classList.add("Active-carousel-image");
                  thumbnailContainer.classList.remove("carousel-hidden");
                }
                matchingCount++; // Increment the count for matching thumbnails
              } else {
                // console.log("not", thumbnail.alt);
                const thumbnailContainer = thumbnail.closest(
                  ".productView-thumbnail"
                );
                if (thumbnailContainer) {
                  thumbnailContainer.classList.remove("Active-carousel-image");
                  thumbnailContainer.classList.add("carousel-hidden");
                }
              }
            });

            // Log the number of matching thumbnails
            console.log(
              `Number of matching thumbnails with alt text "${Active_img_alt}": ${matchingCount} ` 
            );
            // console.log("number of "${this.currentVariant})
            // const hideProductMediaContainers = document.getElementsByClassName("product_media_container");
            // const hideClonedGalleryWrappers = document.getElementsByClassName("cloned-gallery-wrapper");
            // if (matchingCount > 1) {    
                
            //   Array.from(hideProductMediaContainers).forEach((element) => {
            //     element.style.display = "none";
            //   });
            //   Array.from(hideClonedGalleryWrappers).forEach((element) => {
            //     element.style.display = "block";
            //   });

            //   console.log("cloned media wrapper");
            // } else {
            //   Array.from(hideClonedGalleryWrappers).forEach((element) => {
            //     element.style.display = "none";
            //   });
            //   Array.from(hideProductMediaContainers).forEach((element) => {
            //     element.style.display = "block";
            //   });
            //   console.log("product media container")
            // }
           
          }
        } else {
          // console.log("No container with 'productView-thumbnail-link' found.");
        }
      } else {
        element.classList.remove("active-carousel");
       
      }
    });

    // Custom PDP SLider Function Start
    const mediaGalleryWrappers = document.querySelectorAll(
      ".PDP-media-gallery-wrapper"
    );


    // Function for PDP Image Squeeze Fix
document.addEventListener('DOMContentLoaded', () => {
function logInlineWidths() {
  const galleryElements = document.querySelectorAll('.PDP-media-gallery-wrapper');

  if (galleryElements.length === 0) {
    // console.log('No elements with class "PDP-media-gallery-wrapper" found.');
  } else {

galleryElements.forEach((element, index) => {
    const inlineWidth = element.style.width;
    const img_element = element.querySelector('.img-container img');

    if (inlineWidth && inlineWidth !== '0px') {
        // Ensure the image is fully loaded before getting naturalWidth and naturalHeight
        img_element.onload = () => {
            const naturalWidth = img_element.naturalWidth;
            const naturalHeight = img_element.naturalHeight;

            // Check the condition for naturalWidth and naturalHeight
            if (naturalWidth !== 1080 || naturalHeight !== 1350) {
                img_element.style.width = inlineWidth;
                img_element.style.height = inlineWidth;
                img_element.classList.add('custom-pdp-gallery-width');
            }
        };

        // If the image is already loaded (cached), get naturalWidth and naturalHeight directly
        if (img_element.complete) {
            const naturalWidth = img_element.naturalWidth;
            const naturalHeight = img_element.naturalHeight;

            if (naturalWidth !== 1080 || naturalHeight !== 1350) {
                img_element.style.width = inlineWidth;
                img_element.style.height = inlineWidth;
                img_element.classList.add('custom-pdp-gallery-width');
            }
        }
    }
});

  }
}
setTimeout(logInlineWidths, 2500);
});

    
    mediaGalleryWrappers.forEach((wrapper) => {
      const galleryimg = wrapper.querySelector("img");

      if (galleryimg) {
        const imgAlt = galleryimg.getAttribute("alt");
        if (imgAlt == Active_img_alt) {
          wrapper?.classList.add("active-gallery-img");
          wrapper?.classList.remove("carousel-hidden");
        } else {
          wrapper?.classList.remove("active-gallery-img");
          wrapper?.classList.add("carousel-hidden");
        }
        // console.log('galleryImage Alt:', imgAlt);
        // console.log("gallery Active_img_alt",Active_img_alt)
      }
    });
    var product_active_alt = document.getElementById("product_active_img_alt");
    product_active_alt.innerText = Active_img_alt;

    var Active_carousel =
      document.getElementsByClassName("Active-carousel-image") || [];
    var Active_gallery =
      document.getElementsByClassName("active-gallery-img") || [];
    var clonedGallery = document.querySelector(".cloned-gallery");
    var clonedCarousel = document.querySelector(".cloned-carousel");



    // Clear existing content
    clonedGallery.innerHTML = "";
    clonedCarousel.innerHTML = "";


    //PDP Video icon elements
    var clonedGalleryVideo =document.querySelector(".cloned-gallery-video-wrapper");
    var clonedcarouselVideo = document.querySelector('.cloned-carousel-video-wrapper');

    const originalVideo = document.querySelector('.productView-videoPopup');

    if (originalVideo) {
      const clonedVideo = originalVideo.cloneNode(true);
      clonedVideo.classList.add('cloned-gallery-video');
      clonedGalleryVideo.style.position = 'relative';
      clonedGalleryVideo.appendChild(clonedVideo);
      // console.log('Video popup added to cloned gallery');
    }

    const getVideo = originalVideo?.querySelector('.videoPopup-btn');

    if (clonedcarouselVideo && getVideo) {
      const CarouselVideo = getVideo.cloneNode(true);

      CarouselVideo.classList.add('cloned-carousel-video');
      clonedcarouselVideo.style.position = 'relative';

      clonedcarouselVideo.appendChild(CarouselVideo);
    }

    Array.from(Active_gallery).forEach(function (element) {
      var clonedElement = element.cloneNode(true);
      clonedElement.classList.add("dynamic-gallery");
      clonedGallery.appendChild(clonedElement);
    });

    Array.from(Active_carousel).forEach(function (element) {
      var clonedElementForCarousel = element.cloneNode(true);
      clonedElementForCarousel.classList.add("dynamic-carousel");
      clonedCarousel.appendChild(clonedElementForCarousel);
    });
    // Custom PDP SLider Function end

    if (!newMedia) return;
    window.setTimeout(() => {
      $(newMedia).trigger("click");
    }, time);

    if (!this.isFullWidth || window.innerWidth < 768) return;

    const mediaToReplace = document.querySelector(
      '.productView-image[data-index="1"]'
    );
    const imageToReplace = mediaToReplace.querySelector("img");

    if (!this.currentVariant) return;

    const image = this.currentVariant?.featured_image;

    if (image == null) return;

    imageToReplace.setAttribute("src", image.src);
    imageToReplace.setAttribute("srcset", image.src);
    imageToReplace.setAttribute("alt", image.alt);

    if (mediaToReplace.getBoundingClientRect().top < window.scrollY) {
      this.scrollToBlock(mediaToReplace);
    }
  }

  scrollToBlock(block) {
    const headerHeight = document
      .querySelectorAll(".section-header-navigation")[0]
      ?.getBoundingClientRect().height;
    const announcementBarHeight = document
      .querySelectorAll(".announcement-bar")[0]
      ?.getBoundingClientRect().height;
    const positionTop =
      block.getBoundingClientRect().top - headerHeight - announcementBarHeight;

    window.scrollTo({
      top: positionTop,
      behavior: "smooth",
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductAjaxInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `product-price-${this.dataset.product}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        const property = `product-property-${this.dataset.product}`;
        const destinationProperty = document.getElementById(property);
        const sourceProperty = html.getElementById(property);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }

        if (this.checkNeedToConvertCurrency()) {
          let currencyCode = document
            .getElementById("currencies")
            ?.querySelector(".active")
            ?.getAttribute("data-currency");

          Currency.convertAll(
            window.shop_currency,
            currencyCode,
            "span.money",
            "money_format"
          );
        }

        if (destinationProperty) {
          if (sourceProperty) {
            destinationProperty.innerHTML = sourceProperty.innerHTML;
            destinationProperty.style.display = "table";
          } else {
            destinationProperty.style.display = "none";
          }
        } else if (sourceProperty) {
          document
            .querySelector(".productView-product")
            .insertBefore(
              sourceProperty,
              document.querySelector(".productView-options")
            );
        }

        document
          .getElementById(`product-price-${this.dataset.product}`)
          ?.classList.remove("visibility-hidden");
      });
  }

  renderProductInfo() {
    if (this.item.find("[data-sku]").length > 0) {
      this.item
        .find("[data-sku] .productView-info-value")
        .text(this.currentVariant.sku);
        var update_product_detail_sku = document.getElementById('dynamic_variant_Sku');
        if(update_product_detail_sku){
        update_product_detail_sku.innerText=this.currentVariant.sku;
        }
    }

    var inventory = this.currentVariant?.inventory_management;

    if (inventory != null) {
      var arrayInVarName = `product_inven_array_${this.dataset.product}`,
        inven_array = window[arrayInVarName];

      if (inven_array != undefined) {
        var inven_num = inven_array[this.currentVariant.id],
          inventoryQuantity = parseInt(inven_num);

        this.item
          .find('input[name="quantity"]')
          .attr("data-inventory-quantity", inventoryQuantity);

        if (this.item.find("[data-inventory]").length > 0) {
          if (inventoryQuantity > 0) {
            const showStock = this.item
              .find("[data-inventory]")
              .data("stock-level");
            if (showStock == "show") {
              this.item
                .find("[data-inventory] .productView-info-value")
                .text(inventoryQuantity + " " + window.inventory_text.inStock);
            } else {
              this.item
                .find("[data-inventory] .productView-info-value")
                .text(window.inventory_text.inStock);
            }
          } else {
            this.item
              .find("[data-inventory] .productView-info-value")
              .text(window.inventory_text.outOfStock);
          }
        }

        hotStock(inventoryQuantity);
      }
    }

    if (this.item.find(".productView-stickyCart").length > 0) {
      const sticky = this.item.find(".productView-stickyCart");
      const optionSticky = sticky.find(".select__select");

      optionSticky.val(this.currentVariant.id);
    }
  }

  updateProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const description = `[data-product-description-${this.dataset.product}]`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinationDesc = document.querySelector(description);
        const sourceDesc = html.querySelector(description);

        if (sourceDesc && destinationDesc) {
          destinationDesc.innerHTML = sourceDesc.innerHTML;
          if (destinationDesc.closest(".toggle-content--height")) {
            destinationDesc.style.maxHeight = null;
          }
        }
      });
  }

  updateAttribute(unavailable = true, disable = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.product}`)
      ?.querySelector('[name="add"]');
    const addbtnCollection = document.getElementById("product-add-to-cart");
    var nav_outlet = false;
    var quantityInput = this.item.find('input[name="quantity"]'),
      notifyMe = this.item.find(".productView-notifyMe"),
      hotStock = this.item.find(".productView-hotStock"),
      buttonAddtocart = this.item.find(".product-form__submit"),
      maxValue = parseInt(quantityInput.attr("data-inventory-quantity"));

    if (isNaN(maxValue)) {
      maxValue = maxValue = parseInt(
        buttonAddtocart.attr("data-inventory-quantity")
      );
    } else {
      maxValue = parseInt(quantityInput.attr("data-inventory-quantity"));
    }
    if (addbtnCollection.hasAttribute("luggageonlineoutlet")) {
      nav_outlet = true;
    }
    if (unavailable) {
      var text = window.variantStrings.unavailable;

      quantityInput.attr("disabled", true);
      notifyMe.slideUp("slow");
      addButton.setAttribute("disabled", true);
      addButton.textContent = text;
      quantityInput.closest("quantity-input").addClass("disabled");

      if (hotStock.length > 0) hotStock.addClass("is-hiden");
    } else {
      if (disable) {
        var text = window.variantStrings.soldOut;

        quantityInput.attr("data-price", this.currentVariant?.price);
        quantityInput.attr("disabled", true);
        if (!nav_outlet) {
          addButton.setAttribute("disabled", true);
          addButton.textContent = text;
        } else {
          addButton.setAttribute("disabled", false);
          addButton.classList.add("outlet_product");
          addButton.classList.remove("product-form__submit");
          addButton.classList.remove("button");
          addButton.classList.remove("button");
          addButton.style.display = "none";
          var outlet_btn = document.querySelector(".outlet_btn");
          if (outlet_btn) {
            outlet_btn.style.display = "block";
          }
        }
        quantityInput.closest("quantity-input").addClass("disabled");

        if (notifyMe.length > 0) {
          notifyMe
            .find('input[name="halo-notify-product-variant"]')
            .val(this.currentVariant.title);
          notifyMe.find(".notifyMe-text").empty();
          notifyMe.slideDown("slow");
        }
      } else {
        var text,
          subTotal = 0,
          price = this.currentVariant?.price;

        const stickyPrice = $(
          "[data-sticky-add-to-cart] .money-subtotal .money"
        );
        const stickyComparePrice = $(
          "[data-sticky-add-to-cart] .money-compare-price .money"
        );

        if (window.subtotal.show) {
          let qty = quantityInput.val();

          subTotal = qty * price;
          subTotal = Shopify.formatMoney(subTotal, window.money_format);
          subTotal = extractContent(subTotal);

          const moneySpan = document.createElement("span");
          moneySpan.classList.add(
            window.currencyFormatted ? "money" : "money-subtotal"
          );
          moneySpan.innerText = subTotal;
          document.body.appendChild(moneySpan);

          if (this.checkNeedToConvertCurrency()) {
            let currencyCode = document
              .getElementById("currencies")
              ?.querySelector(".active")
              ?.getAttribute("data-currency");
            Currency.convertAll(
              window.shop_currency,
              currencyCode,
              "span.money",
              "money_format"
            );
          }

          subTotal = moneySpan.innerText;
          $(moneySpan).remove();

          if (window.subtotal.style == "1") {
            const pdView_subTotal =
              document.querySelector(".productView-subtotal .money") ||
              document.querySelector(".productView-subtotal .money-subtotal");
            if (pdView_subTotal != null) {
              pdView_subTotal.textContent = subTotal;
            }

            if (
              this.currentVariant.available &&
              maxValue <= 0 &&
              this.currentVariant.inventory_management == "shopify"
            ) {
              text = window.variantStrings.preOrder;
            } else {
              text = window.variantStrings.addToCart;
            }
          } else if (window.subtotal.style == "2") {
            text = window.subtotal.text.replace("[value]", subTotal);
          }
        } else {
          subTotal = Shopify.formatMoney(price, window.money_format);
          subTotal = extractContent(subTotal);
          if (
            this.currentVariant.available &&
            maxValue <= 0 &&
            this.currentVariant.inventory_management == "shopify"
          ) {
            text = window.variantStrings.preOrder;
          } else {
            text = window.variantStrings.addToCart;
          }
        }
        if (nav_outlet) {
          addButton.classList.remove("outlet_product");
          addButton.classList.add("product-form__submit");
          addButton.classList.add("button");
          addButton.style.display = "block";
          var outlet_btn = document.querySelector(".outlet_btn");
          if (outlet_btn) {
            outlet_btn.style.display = "none";
          }
        }
        quantityInput.attr("data-price", this.currentVariant?.price);
        quantityInput.attr("disabled", false);
        addButton.removeAttribute("disabled");
        addButton.textContent = text;
        quantityInput.closest("quantity-input").removeClass("disabled");

        if (subTotal != 0 && stickyPrice.length) {
          stickyPrice.text(subTotal);
        }

        if (
          subTotal != 0 &&
          stickyComparePrice.length &&
          window.subtotal.show
        ) {
          let comparePrice = $(
              "[data-sticky-add-to-cart] .money-compare-price"
            ).data("compare-price"),
            qty = quantityInput.val();
          comparePrice = qty * comparePrice;
          comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
          comparePrice = extractContent(comparePrice);
          stickyComparePrice.text(comparePrice);
        }

        if (notifyMe.length > 0) {
          notifyMe.slideUp("slow");
        }
      }
    }
  }

  updateStickyAddToCart(unavailable = true, disable = true) {
    if (this.item.find(".productView-stickyCart").length > 0) {
      const sticky = this.item.find(".productView-stickyCart");
      const itemImage = sticky.find(".sticky-image");
      const option = sticky.find(".select__select");
      const input = document
        .getElementById(`product-form-sticky-${this.dataset.product}`)
        ?.querySelector('input[name="id"]');
      const button = document
        .getElementById(`product-form-sticky-${this.dataset.product}`)
        ?.querySelector('[name="add"]');
      var quantityInput = this.item.find('input[name="quantity"]');
      var maxValue = parseInt(quantityInput.attr("data-inventory-quantity"));

      if (unavailable) {
        var text = window.variantStrings.unavailable;

        button.setAttribute("disabled", true);
        button.textContent = text;
      } else {
        if (!this.currentVariant) return;

        const image = this.currentVariant?.featured_image;

        if (image != null) {
          itemImage.find("img").attr({
            src: image.src,
            srcset: image.src,
            alt: image.alt,
          });
        }

        option.val(this.currentVariant.id);

        if (disable) {
          var text = window.variantStrings.soldOut;

          button.setAttribute("disabled", true);
          button.textContent = text;
        } else {
          if (
            this.currentVariant.available &&
            maxValue <= 0 &&
            this.currentVariant.inventory_management == "shopify"
          ) {
            text = window.variantStrings.preOrder;
          } else {
            text = window.variantStrings.addToCart;
          }

          button.removeAttribute("disabled");
          button.textContent = text;
        }

        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  checkNeedToConvertCurrency() {
    var currencyItem = $(".dropdown-item[data-currency]");
    if (currencyItem.length) {
      return (
        (window.show_multiple_currencies &&
          Currency.currentCurrency != shopCurrency) ||
        window.show_auto_currency
      );
    } else {
      return;
    }
  }

  checkQuantityWhenVariantChange() {
    var quantityInput = this.closest(".productView-details").querySelector(
      "input.quantity__input"
    );
    var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
    var inputValue = parseInt(quantityInput?.value);

    let value = inputValue;

    if (inputValue > maxValue && maxValue > 0) {
      value = maxValue;
    } else {
      value = inputValue;
    }

    if (value < 1 || isNaN(value)) value = 1;

    if (quantityInput) {
      quantityInput.value = value;
    }

    document.getElementById("product-add-to-cart").dataset.available =
      this.currentVariant.available && maxValue <= 0;
  }

  updateVariantStatuses() {
    Create_slider();
    // const options = this.item.find('.productView-details .product-form__input'),
    //     optionsLength = options.length,
    //     pvOptionsLength = PVoptions.length,
    //     checkStickyVariant = false;

    // optionsLength > pvOptionsLength ? checkStickyVariant = true : '';

    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    const firstOptionValue = inputWrappers[0].querySelector(":checked").value;
    const productColorTitle = document.querySelector(".product-color-title");
    productColorTitle.innerText = " " + "-" + " " + firstOptionValue;
    const inputLength = inputWrappers.length;

    //is Exclusive metafields
    debugger;
//     const isExclusiveVariantName = this.currentVariant;
//     // console.log("Test", isExclusiveVariantName.id);
//    if (!isExclusiveVariantName || !isExclusiveVariantName.id) {
//   console.log("Variant not available or invalid combination");
//   return;
// }
//     const mainDivs = document.querySelectorAll(".variant_isExclusive");

//     mainDivs.forEach((div) => {
//       const dataVariantId = div.getAttribute("data-variant-id");
//       const exclusiveValue = div.getAttribute("Exclusive");
//       if (isExclusiveVariantName.id == dataVariantId) {
//         // console.log("test Exclusive Value:", exclusiveValue);
//         document.getElementById("variant_metafields").innerHTML =
//           exclusiveValue;
//       }
//     });
const isExclusiveVariantName = this.currentVariant;

//  Invalid or unavailable variant → show message
if (!isExclusiveVariantName || !isExclusiveVariantName.id) {
  console.log("Variant not available or invalid combination");

  const popup = document.getElementById("variant_metafields");
  if (popup) {
    popup.innerHTML = "Unavailable";
  }

  return;
}

const mainDivs = document.querySelectorAll(".variant_isExclusive");

let found = false;

mainDivs.forEach((div) => {
  const dataVariantId = div.getAttribute("data-variant-id");
  const exclusiveValue = div.getAttribute("Exclusive");

  if (isExclusiveVariantName.id == dataVariantId) {
    found = true;

    const popup = document.getElementById("variant_metafields");
    if (popup) {
      popup.innerHTML = exclusiveValue;
    }
  }
});

// ONLY show message if NOT found
if (!found) {
  const popup = document.getElementById("variant_metafields");
  if (popup) {
    popup.innerHTML = "Not available";
  }
}

    inputWrappers.forEach((option, index) => {
      option.querySelector("[data-header-option]").innerText =
        option.querySelector(":checked").value;
      if (index === 0 && inputLength > 1) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputLength > 1
          ? inputWrappers[index - 1].querySelector(":checked").value
          : inputWrappers[index].querySelector(":checked").value;
      const optionInputsValue =
        inputLength > 1
          ? selectedOptionOneVariants
              .filter(
                (variant) =>
                  variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])
          : this.variantData.map(
              (variantOption) => variantOption[`option${index + 1}`]
            );
      const availableOptionInputsValue =
        inputLength > 1
          ? selectedOptionOneVariants
              .filter(
                (variant) =>
                  variant.available &&
                  variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])
          : this.variantData
              .filter((variant) => variant.available)
              .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(
        optionInputs,
        optionInputsValue,
        availableOptionInputsValue
      );
    });

    // Assuming you want to log the value when the page loads
    // const labels = document.querySelectorAll('.product-form__label');

    // labels.forEach(label => {
    //   const data_variant_id = label.getAttribute('data-variant-id');
    //   const exclusiveValue = label.getAttribute('exclusive');
    //     if ( isExclusiveVariantName.id == data_variant_id ){
    //         console.log('Test Exclusive Value:', exclusiveValue,data_variant_id);
    //         document.getElementById("variant_metafields").innerHTML = exclusiveValue;
    //     }
    // });
  }

  setInputAvailability(
    optionInputs,
    optionInputsValue,
    availableOptionInputsValue
  ) {
    optionInputs.forEach((input) => {
      if (availableOptionInputsValue.includes(input.getAttribute("value"))) {
        input.classList.remove("soldout");
        input.innerText = input.getAttribute("value");
      } else {
        input.classList.add("soldout");
        optionInputsValue.includes(input.getAttribute("value"))
          ? (input.innerText = input.getAttribute("value") + " (Sold out)")
          : (input.innerText =
              window.variantStrings.unavailable_with_option.replace(
                "[value]",
                input.getAttribute("value")
              ));
      }
    });
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(
    optionInputs,
    optionInputsValue,
    availableOptionInputsValue
  ) {
    optionInputs.forEach((input) => {
      if (availableOptionInputsValue.includes(input.getAttribute("value"))) {
        input.nextSibling.classList.remove("soldout", "unavailable");
        input.nextSibling.classList.add("available");
      } else {
        input.nextSibling.classList.remove("available", "unavailable");
        input.nextSibling.classList.add("soldout");

        if (
          window.variantStrings.hide_variants_unavailable &&
          !optionInputsValue.includes(input.getAttribute("value"))
        ) {
          input.nextSibling.classList.add("unavailable");
          if (!input.checked) return;
          let inputsValue;
          availableOptionInputsValue.length > 0
            ? (inputsValue = availableOptionInputsValue)
            : (inputsValue = optionInputsValue);
          input
            .closest(".product-form__input")
            .querySelector(`input[value="${inputsValue[0]}"]`).checked = true;
          this.dispatchEvent(new Event("change"));
        }
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    if (!this.checkHasMultipleVariants()) {
      this.initProductQuantity();
      this.checkVariantInventory();
    }
  }

  onInputChange(event) {
    event.preventDefault();
    var inputValue = this.input.value;
    var maxValue = parseInt(this.input.dataset.inventoryQuantity);
    var currentId = document
      .getElementById(`product-form-${this.input.dataset.product}`)
      ?.querySelector('[name="id"]')?.value;
    var saleOutStock =
      document.getElementById("product-add-to-cart").dataset.available ===
        "true" || false;
    const addButton = document
      .getElementById(`product-form-${this.input.dataset.product}`)
      ?.querySelector('[name="add"]');

    if (inputValue < 1) {
      inputValue = 1;

      this.input.value = inputValue;
    }

    if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
      var arrayInVarName = `selling_array_${this.input.dataset.product}`,
        itemInArray = window[arrayInVarName],
        itemStatus = itemInArray[currentId];

      if (itemStatus == "deny") {
        inputValue = maxValue;
        this.input.value = inputValue;
        const message = getInputMessage(maxValue);
        showWarning(message, 3000);
      }
    } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
      this.input.value = inputValue;
    }

    if (window.subtotal.show) {
      var text,
        price = this.input.dataset.price,
        subTotal = 0;

      var parser = new DOMParser();

      subTotal = inputValue * price;
      subTotal = Shopify.formatMoney(subTotal, window.money_format);
      subTotal = extractContent(subTotal);

      const moneySpan = document.createElement("span");
      moneySpan.classList.add(
        window.currencyFormatted ? "money" : "money-subtotal"
      );
      moneySpan.innerText = subTotal;
      document.body.appendChild(moneySpan);

      if (this.checkNeedToConvertCurrency()) {
        let currencyCode = document
          .getElementById("currencies")
          ?.querySelector(".active")
          ?.getAttribute("data-currency");
        Currency.convertAll(
          window.shop_currency,
          currencyCode,
          "span.money",
          "money_format"
        );
      }

      subTotal = moneySpan.innerText;
      $(moneySpan).remove();

      if (window.subtotal.style == "1") {
        const pdView_subTotal =
          document.querySelector(".productView-subtotal .money") ||
          document.querySelector(".productView-subtotal .money-subtotal");

        pdView_subTotal.textContent = subTotal;
      } else if (window.subtotal.style == "2") {
        text = window.subtotal.text.replace("[value]", subTotal);

        addButton.textContent = text;
      }

      const stickyPrice = $("[data-sticky-add-to-cart] .money-subtotal .money");
      const stickyComparePrice = $(
        "[data-sticky-add-to-cart] .money-compare-price .money"
      );

      if (stickyPrice.length) {
        stickyPrice.text(subTotal);
      }

      if (stickyComparePrice.length && window.subtotal.show) {
        let comparePrice = $(
          "[data-sticky-add-to-cart] .money-compare-price"
        ).data("compare-price");
        comparePrice = inputValue * comparePrice;
        comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
        comparePrice = extractContent(comparePrice);
        stickyComparePrice.text(comparePrice);
      }
    }

    if (
      this.classList.contains("quantity__group--2") ||
      this.classList.contains("quantity__group--3")
    ) {
      const mainQty = document.querySelector(
        ".quantity__group--1 .quantity__input"
      );
      mainQty.value = inputValue;

      const mainQty2Exists = !!document.querySelector(
        ".quantity__group--2 .quantity__input"
      );
      const mainQty3Exists = !!document.querySelector(
        ".quantity__group--3 .quantity__input"
      );

      if (this.classList.contains("quantity__group--2") && mainQty3Exists) {
        const mainQty3 = document.querySelector(
          ".quantity__group--3 .quantity__input"
        );
        mainQty3.value = inputValue;
      } else if (
        this.classList.contains("quantity__group--3") &&
        mainQty2Exists
      ) {
        const mainQty2 = document.querySelector(
          ".quantity__group--2 .quantity__input"
        );
        mainQty2.value = inputValue;
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  checkHasMultipleVariants() {
    const arrayInVarName = `product_inven_array_${
      this.querySelector("[data-product]").dataset.product
    }`;
    this.inven_array = window[arrayInVarName];
    return Object.keys(this.inven_array).length > 1;
  }

  initProductQuantity() {
    if (this.inven_array != undefined) {
      var inven_num = Object.values(this.inven_array),
        inventoryQuantity = parseInt(inven_num);

      this.querySelector('input[name="quantity"]').setAttribute(
        "data-inventory-quantity",
        inventoryQuantity
      );
      this.querySelector('input[name="quantity"]').dataset.inventoryQuantity =
        inventoryQuantity;
    }
  }

  checkVariantInventory() {
    const addBtn = document.getElementById("product-add-to-cart");
    this.input.disabled = addBtn.disabled;
    this.querySelector(".btn-quantity.minus").disabled = addBtn.disabled;
    this.querySelector(".btn-quantity.plus").disabled = addBtn.disabled;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        document.querySelector('.product-option [type="application/json"]')
          .textContent
      );
    return this.variantData;
  }
}

customElements.define("quantity-input", QuantityInput);

function hotStock(inventoryQuantity) {
  const productView = document.querySelector(".productView");
  const hotStock = productView.querySelector(".productView-hotStock");
  if (hotStock) {
    let hotStockText = hotStock.querySelector(".hotStock-text"),
      maxStock = parseFloat(hotStock.dataset.hotStock),
      textStock;

    if (inventoryQuantity > 0 && inventoryQuantity <= maxStock) {
      hotStock.matches(".style-2")
        ? (textStock = window.inventory_text.hotStock2.replace(
            "[inventory]",
            inventoryQuantity
          ))
        : (textStock = window.inventory_text.hotStock.replace(
            "[inventory]",
            inventoryQuantity
          ));
      hotStockText.innerHTML = textStock;
      hotStock.classList.remove("is-hide");
    } else {
      hotStock.classList.add("is-hide");
    }

    if (hotStock.matches(".style-2")) {
      const invenProgress = (inventoryQuantity / maxStock) * 100,
        hotStockProgressItem = hotStock.querySelector(
          ".hotStock-progress-item"
        );
      hotStockProgressItem.style.width = `${invenProgress}%`;
    }
  }
}
const hotStockNoOptions = document.querySelector(
  ".productView .productView-hotStock[data-current-inventory]"
);
if (hotStockNoOptions) {
  const inventoryQuantity = parseFloat(
    hotStockNoOptions.dataset.currentInventory
  );
  hotStock(inventoryQuantity);
}

function showWarning(content, time = null) {
  if (window.warningTimeout) {
    clearTimeout(window.warningTimeout);
  }
  const warningPopupContent = document
    .getElementById("halo-warning-popup")
    .querySelector("[data-halo-warning-content]");
  warningPopupContent.textContent = content;
  document.body.classList.add("has-warning");

  if (time) {
    window.warningTimeout = setTimeout(() => {
      document.body.classList.remove("has-warning");
    }, time);
  }
}

function getInputMessage(maxValue) {
  var message = window.cartStrings.addProductOutQuantity.replace(
    "[maxQuantity]",
    maxValue
  );
  return message;
}

var outlet_wrapper = document.querySelector(".outlet_btn");
if (outlet_wrapper) {
  outlet_wrapper.addEventListener("click", executeoutlet);
}
function executeoutlet() {
  var add_outlet_btn = document.querySelector(".outlet_btn");
  var outletURL = add_outlet_btn.getAttribute("outlet-url");
  // console.log("outletURL", outletURL);
  var outlet_wrapper = document.querySelector("#outlet_info_content");
  while (outlet_wrapper.firstChild) {
    outlet_wrapper.removeChild(outlet_wrapper.firstChild);
  }
  if (outlet_wrapper && outlet_wrapper.innerText.trim() !== "") {
    outlet_wrapper.innerText = "";
  }
  var current_url = window.location.href;
  var url_params = current_url.split("?")[0];
  var variant_id = current_url.split("=")[1];
  var url_fetch = url_params + ".js";
  var sku_wrapper = document.querySelector(".productView-info-item[data-sku]");
  var sku_id = sku_wrapper.querySelector(".productView-info-value");
  var product_title = document.querySelector(".productView-title");
  var title_tag = document.createElement("p");
  title_tag.classList.add("outlet_product_title");
  title_tag.innerText = product_title.innerText;
  outlet_wrapper.appendChild(title_tag);
  // console.log("variant_id", variant_id);
  var outlet_buy_btn = document.createElement("a");
  outlet_buy_btn.classList.add("buy_outlet");
  outlet_buy_btn.setAttribute("target", "_blank");

  outlet_buy_btn.innerText = "BUY NOW AT OUTLET";
  if (outletURL) {
    outlet_buy_btn.setAttribute("href", outletURL);
  } else {
    outlet_buy_btn.setAttribute("href", "https://luggageonlineoutlet.com");
  }

  fetch(url_fetch)
    .then((response) => response.json())
    .then((data) => {
      console.log("JSON data:", data.variants);
      // Process the fetched JSON data here
      data.variants.forEach((variant) => {
        if (variant.id == variant_id) {
          // console.log("Variant ID:", variant.id);
          var variant_price = variant.price;
          var format_price = (variant_price / 100).toFixed(2);
          var variant_prcie = document.createElement("p");
          variant_prcie.classList.add("outlet_product_price");
          variant_prcie.innerText = "$" + " " + format_price;
          if (variant.featured_image && variant.featured_image.src) {
            var img_src = variant.featured_image.src;
          }
          var img_element = document.createElement("img");
          img_element.classList.add("outlet_product_image");
          img_element.setAttribute("src", img_src);
          var title_element = document.querySelector(".outlet_product_title");
          if (title_element) {
            title_element.insertAdjacentElement("beforebegin", img_element);
            title_element.insertAdjacentElement("afterend", variant_prcie);
            variant_prcie.insertAdjacentElement("afterend", outlet_buy_btn);
          }
        }
      });
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });

  // pop trigger start
  var outlet_modal = document.getElementById("outlet_myModal");
  var outlet_span = document.getElementsByClassName("outlet_close")[0];
  outlet_modal.style.display = "block";
  var header_sticky = document.querySelector(".section-header-classic");
  var header_menu = document.querySelector(".shopify-section-header-sticky");
  header_sticky.style.zIndex = 0;
  header_menu.style.zIndex = 0;
  outlet_span.onclick = function () {
    outlet_modal.style.display = "none";
    header_sticky.style.zIndex = 23;
    header_menu.style.zIndex = 22;
  };
  // pop trigger end
}
